import "./ForensicServices.module.css";
import Header from "@/reusable_sections/Header";
import SpecializedThreatMatrix from "./sections/SpecializedThreatMatrix";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ForensicServicesPage() {
  return <div>
      <Header />
      <SpecializedThreatMatrix />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}